export const FACEBOOK_PIXEL_EVENT = {
  // Awareness / top of funnel
  PAGE_VIEW: 'PageView', // baseline event (fires automatically if pixel installed)
  VIEW_CONTENT: 'ViewContent', // pricing/features page views

  // Mid-funnel / intent
  COMPLETE_REGISTRATION: 'CompleteRegistration', // when user signs up (free account)

  // Conversion
  START_TRIAL: 'StartTrial', // when free trial actually starts
  SUBSCRIBE: 'Subscribe' // when payment starts (paid plan active)
}
